<template>
  <div class="expertCardComponent" @click="toExpertDetail(info)">
    <div
      class="active_photo"
      :style="{ backgroundImage: `url(${info.head|| info.headUrl})` }"
    ></div>
     <h4 class="expert_h4">{{ info.name }}</h4>
    <div class="expert_box">
      <p>{{info.expertDes}}</p>
    </div>
    <span class="active_colors">
      <i class="el-icon-arrow-right iconx_s"></i>
    </span>
  </div>
</template>
<script>
import {routerGoNewpage} from "@/utils/index"
export default {
  name: "expertCardComponent",
  props: {
    info: {
      type: Object,
    },
  },
  methods: {
    toExpertDetail(item) {
      routerGoNewpage("/expert_detail",{ id: (item.user_id || item.userId) })
    },
  },
};
</script>
<style lang="less" scoped>
.expertCardComponent {
  position: relative;
  text-align: center;
  background: #f6f6f6;
  padding: 15px 15px;
  transition: 0.3s;
  height: 292px;
  margin-top: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-width: 230.5px;
  cursor: pointer;
  &:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
    .active_colors {
      background: #50b035;
    }
  }
  img {
    width: 94px;
    height: 97px;
    position: absolute;
    top: 25px;
    left: 12px;
  }
  // p {
  //   &:nth-of-type(2) {
  //     text-align: left;
  //     font-size: 14px;
  //     font-family: Microsoft YaHei;
  //     font-weight: 400;
  //     color: #999999;
  //   }
  // }
  span {
    cursor: pointer;
    display: block;
    position: absolute;
    left: 50%;
    bottom:20px;
    transform: translate(-15px);
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
    text-align: center;
    // background: url("../../assets/images/arrow.png") no-repeat center/100%;
    margin-top: 20px;
  }
  .active_photo {
    width: 120px;
    height: 120px;
    overflow: hidden;
    position: absolute;
    background: #ffb15d;
    border-radius: 100%;
    top: -20%;
    right: 50%;
    margin-right: -60px;
    background-position: center;
    background-size: cover;
  }
  .iconx {
    color: #ffffff;
    padding-top: 6px;
  }
  .iconx_s {
    color: #dcdcdc;
    padding-top: 6px;
  }
  .active_colors {
    border: 1px solid #dcdcdc;
  }
}
.expert_h4{
  height: 30px;
}
.expert_box{
  width: 100%;
  height: 100px;
  overflow: hidden;
}
.expert_box p{
  text-align: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 24px;
  padding: 0px 15px;
  
}
</style>



// WEBPACK FOOTER //
// src/components/expertCard.vue